import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithCustomToken } from "firebase/auth";
import { auth } from "../fb";

// Get uid of the current user
export const getCurrentUser = () => {
    return auth.currentUser;
};

export const getUid = () => {
    return auth.currentUser?.uid;
}

export const login = (email: string, password: string) => {
    // Handle login and return promise
    return new Promise((resolve, reject) => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                resolve(user);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage);
                if (errorCode === 'auth/invalid-credential') {
                    reject(new Error(`Invalid email or password.`));
                } else if (errorCode === 'auth/wrong-password') {
                    reject(new Error(`Wrong password.`));
                } else if (errorCode === 'auth/user-not-found') {
                    reject(new Error(`User not found.`));
                } else if (errorCode === 'auth/invalid-email') {
                    reject(new Error(`Invalid email.`));
                } else if (errorCode === 'auth/too-many-requests') {
                    reject(new Error(`Too many requests.`));
                } else if (errorCode === 'auth/user-disabled') {
                    reject(new Error(`User disabled.`));
                } else if (errorCode === 'auth/network-request-failed') {
                    reject(new Error(`Network request failed.`));
                } else if (errorCode === 'auth/operation-not-allowed') {
                    reject(new Error(`Operation not allowed.`));
                } else {
                    reject(new Error(errorMessage));
                }
            });
    });

    // return signInWithEmailAndPassword(auth, email, password);
};

export const loginWithToken = (token: string) => {
    return signInWithCustomToken(auth, token);
};

export const register = (email: string, password: string) => {
    return createUserWithEmailAndPassword(auth, email, password);
};

export const logout = () => {
    return auth.signOut();
};

// Get user token
export const getToken = () => {
    return auth.currentUser?.getIdToken();
};